import React from 'react';
import proxyway from '../assets/proxyway-logo.svg';
import takeoff from '../assets/takeoff-logo.png';
import uantwerpen from '../assets/uantwerpen-logo.png';
import hidden from '../assets/hidden.jpg';
import minted from '../assets/minted.jpg';

function Stats() {
    const stats = [
        { value: "1,000+", label: "Trusted Members" },
        { value: "30,000+", label: "Successful Checkouts" },
        { value: "24/7", label: "Support" },
        { value: "99.9%", label: "Uptime" }
    ];

    const recognitions = [
        { name: "Proxyway", logo: proxyway, link: "https://www.youtube.com/watch?v=L254MvZP7Ug" },
        { name: "Takeoff Antwerp", logo: takeoff, link: null },
        { name: "University of Antwerp", logo: uantwerpen, link: null },
        { name: "Hidden NY", logo: hidden, link: null },
        { name: "Minted", logo: minted, link: null }
    ];

    return (
        <div className="py-12 md:py-16 flex flex-col gap-10">
            {/* Stats Grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
                {stats.map((stat, index) => (
                    <div 
                        key={index}
                        className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700 rounded-2xl p-6 md:p-8 text-center hover:border-fuse-orange transition-colors"
                    >
                        <div className="text-3xl md:text-5xl font-bold text-fuse-orange mb-2">
                            {stat.value}
                        </div>
                        <div className="text-sm md:text-base text-gray-400">
                            {stat.label}
                        </div>
                    </div>
                ))}
            </div>

            {/* Recognition Section */}
            <div className="text-center">
                <div className="h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent mb-8"></div>
                <div className="flex flex-wrap justify-center items-center gap-12 md:gap-16">
                    {recognitions.map((recognition, index) => (
                        recognition.link ? (
                            <a 
                                key={index}
                                href={recognition.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="transition-all duration-300 opacity-60 hover:opacity-100"
                                style={{ 
                                    filter: 'grayscale(100%) brightness(2) invert(1)',
                                }}
                            >
                                <img 
                                    src={recognition.logo} 
                                    alt={recognition.name}
                                    className="h-12 md:h-14 w-auto object-contain"
                                />
                            </a>
                        ) : (
                            <div 
                                key={index}
                                className="opacity-60"
                                style={{ 
                                    filter: 'grayscale(100%) brightness(2) invert(1)',
                                }}
                            >
                                <img 
                                    src={recognition.logo} 
                                    alt={recognition.name}
                                    className="h-12 md:h-14 w-auto object-contain"
                                />
                            </div>
                        )
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Stats;

